/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace whitespace */

import { Injectable  }           from '@angular/core';
import { HttpClient }           from '@angular/common/http';
import { HttpHeaders }           from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

import { User }                  from '@/models/user';
import { FAVRecord }             from "@/models/project/f.a.v.record";
import { first }                 from "rxjs/operators";
import { Logger }                from "@/util/logger";

@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class DatabridgeService
 *
 * Remote access to BigQuery via the databridge service
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class DatabridgeService {

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {

  }

  /** fetch any headers we need to send along with our request */
  headers(): HttpHeaders {

    const user: User = this.auth.userOfSession;

    if (!user) {

      /* no user logged in */

      return null;
    }

    return new HttpHeaders().set('Authorization', `Bearer ${user.token}`);
  }

  /** generate the list of raw FAVRecords available in the BigQuery prepared data area */
  public favList(): Promise<FAVRecord[]> {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    /*
     * return a promise so that they wait for the remote response, and so that we can
     * format the results as FAVRecord objects.
     *
     */

    return new Promise((resolve, reject) => {

      Logger.debug('[databridge] fetching FAV pick list...');

      this.http.get<string>(`/backend/fav/prepared/list`, {
         headers
      }).pipe(first())
        .subscribe(
          (result: any) => {

            Logger.debug('[databridge] FAV received: ', result);

            let fav: FAVRecord[] = [];

            result.forEach((item: any) => {

              fav.push(new FAVRecord(item));
            });

            /* pass back the FAV list */

            resolve(fav);
          },
          (error) => {

            Logger.debug('[databridge] remote error: ', error);

            /* bail! */

            reject(error);

          });
    });
  }


}
